var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tile-grid',_vm._l((_vm.getScenes),function(sceneItem){return _c('scene-tile',{key:sceneItem.id,attrs:{"scene":sceneItem,"edit-enabled":_vm.scene.isEditModeEnabled}})}),1),_c('scene-modal-form',{ref:"addSceneModal",attrs:{"title":_vm.$t('add-scene')},on:{"ok":_vm.addSceneOk}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }